import React from 'react';
import { RoundButton } from '../buttons/base/RoundButton';
import { translate } from '../../core/i18n';

export const CodeEntryAreaSwitch = ( props : { isVisible } ) => {
    return (
        <RoundButton id="keyboard-helper" icon="keyboard" className="m-1" 
                     onClick={props.isVisible} title={translate('keyboard-helper-switch')} text='"()=,'/>
    );
};
